import Ionicons from '@expo/vector-icons/Ionicons';
import React from 'react';
import { Pressable, Text, View } from 'react-native';

export interface SettingsItemData {
  icon: string;
  title: string;
  action: () => void;
  disabled?: boolean;
}

export interface SettingsToggleItemData {
  icon: string;
  title: string;
  value: boolean;
  onToggle: (value: boolean) => void;
  disabled?: boolean;
}

interface SettingsItemProps {
  item: SettingsItemData;
  isLast?: boolean;
}

export function SettingsItem({ item, isLast = false }: SettingsItemProps) {
  return (
    <Pressable
      onPress={item.action}
      className={`flex-row items-center py-4 ${!isLast ? 'border-b border-border' : ''}`}
      style={{
        opacity: item.disabled ? 0.4 : 1,
      }}
      disabled={item.disabled}
    >
      <View className="w-8 items-center mr-3">
        <Ionicons
          name={item.icon as any}
          size={22}
          className={item.disabled ? 'text-muted-foreground' : 'text-foreground'}
        />
      </View>
      <Text
        className={`flex-1 text-base ${item.disabled ? 'text-muted-foreground' : 'text-foreground'}`}
      >
        {item.title}
      </Text>
      <Ionicons
        name="chevron-forward"
        size={20}
        className="text-muted-foreground"
      />
    </Pressable>
  );
}
